module.exports = __webpack_public_path__ + "static/img/ic_community_d.8b9a4dad.png";